/* eslint-disable no-underscore-dangle */
import { createAction } from '@reduxjs/toolkit';
import type { User } from '../models/admin_user';
import AdminUser from '../models/admin_user';
import type { AppThunk } from '../store/configureStore';
import { initUserPrivateMoney } from './user-private-money';
import { throwOnError } from './utils';

export const SET_USER_INFO = createAction<User>('SET_USER_INFO');

export const getUserInfo = (): AppThunk => (dispatch) =>
  fetch('/api/user', {
    method: 'GET',
    credentials: 'same-origin',
  })
    .then(throwOnError<User>)
    .then((json) => {
      if (!json) return;
      if ((window as any).dataLayer) {
        (window as any).dataLayer.push({
          organization_code: json.organization.code,
          admin_user_id: json.id,
        });
      }
      const adminUser = new AdminUser(json);
      const defaultMoney = adminUser.defaultMoney();
      const avialbleMoneys = adminUser.isServiceUser()
        ? adminUser.privateMoneys ?? []
        : adminUser.moneys();
      if (defaultMoney) {
        dispatch(initUserPrivateMoney(defaultMoney, avialbleMoneys));
      }
      dispatch(SET_USER_INFO(json));
    });

export const getUsers = (query = '') =>
  fetch(`/api/users?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then((response) => response.json());

export const getUser = (id: string) =>
  fetch(`/api/users/${id}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then((response) => response.json());

export const inviteUser = ({ email, role, shops, org }) =>
  fetch('/api/users', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({
      email,
      role,
      shops,
      _csrf_token: (window as any)._csrf_token,
      ...(org ? { organization_code: org.code } : null),
    }),
  });

export const getInvitations = (query = '') =>
  fetch(`/api/users/invitations?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then((response) => response.json());

export const resendInvitation = (id: string) =>
  fetch(`/api/users/invitations/${id}`, {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: (window as any)._csrf_token }),
  });

export const registerUser = (data: Record<string, unknown> = {}) =>
  fetch('/verify', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...data }),
  });

export const deleteUser = (id: string) =>
  fetch(`/api/users/${id}`, {
    method: 'DELETE',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: (window as any)._csrf_token }),
  }).then((response) => response.json());

export const updateUser = (id: string, data: Record<string, unknown> = {}) =>
  fetch(`/api/users/${id}`, {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...data }),
  });

export const resetUser = (organization: string, email: string) =>
  fetch('/reset', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ organization, email, _csrf_token: (window as any)._csrf_token }),
  });
